import { render, staticRenderFns } from "./thirdClass.vue?vue&type=template&id=699dbd6a&scoped=true&"
import script from "./thirdClass.vue?vue&type=script&lang=js&"
export * from "./thirdClass.vue?vue&type=script&lang=js&"
import style0 from "./thirdClass.vue?vue&type=style&index=0&id=699dbd6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699dbd6a",
  null
  
)

export default component.exports